module.exports = __webpack_public_path__ + "img/dps-proximo.21b98f09.svg";